import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentmainessay";

export default function MainEssayForProfile({ slug }) {
  const [mainEssaydb, setMainEssayDb] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [fiveAdjectives, setFiveAdjectives] = useState("");
  const [instructorComment, setInstructorComment] = useState("");
  const [studentComment, setStudentComment] = useState("");
  const [isShared, setIsShared] = useState("");
  const [mainEssay, setMainEssay] = useState("");

  async function getDatafromMainEssay() {
    const mainEssayfromdb = await getStudentIdData(slug);
    setPrompt(mainEssayfromdb[0].prompt);
    setInstructorComment(mainEssayfromdb[0].instructorComment);
    setFiveAdjectives(mainEssayfromdb[0].fiveAdjectives);
    setStudentComment(mainEssayfromdb[0].studentComment);
    setMainEssay(mainEssayfromdb[0].mainEssay);
    setIsShared(mainEssayfromdb[0].isShare);
    console.log("Main Essay: ", mainEssayfromdb);
    setMainEssayDb(mainEssayfromdb);
  }

  useEffect(() => {
    getDatafromMainEssay();
  }, [setMainEssayDb]);

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <h4 className="goal_settings_title">Main College Essay</h4>
          <div className="wishlist-item mt-5">
            <div style={{ color: "black", backgroundColor: "white" }}>
              <div className="mb-3">
                <label className="form-label fw-bold">Prompt:</label>
                <div>{prompt}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Five Adjectives:</label>
                <div>{fiveAdjectives}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">
                  Instructor Comment:
                </label>
                <div>{instructorComment}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Student Comment:</label>
                <div>{studentComment}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Shared:</label>
                <div>
                  {" "}
                  <input
                    type="checkbox"
                    checked={isShared}
                    readOnly
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">
                  Main College Essay:
                </label>
                <div
                  style={{ lineHeight: "1.6", marginTop: "10px" }}
                  dangerouslySetInnerHTML={{ __html: mainEssay }}
                />
              </div>
              {/* <div className="mb-3">
        <label className="form-label fw-bold">Main College Essay:</label>
        <div style={{ lineHeight: "1.6", marginTop: "10px" }}>
          {mainEssay.split("\n").map((paragraph, index) => (
            <div key={index} style={{ marginBottom: "15px" }}>
              {paragraph}
            </div>
          ))}
        </div> 
      </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
